// ----------------------------------------------------------------------
// <copyright file="Izenda.DatabaseConfiguration.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//
// </copyright>
// ----------------------------------------------------------------------

/**
 * Database Configuration component
 */
!(function() {
  var React = require('react');
  var Panel = require('share/components/controls/Izenda.Panel');
  var ConnectionStringForm = require('./Izenda.ConnectionStringForm');
  var LicenseCheckerConstants = require('logic/data/Izenda.LicenseCheckerConstants');
  var EmailConstants = require('logic/data/Izenda.EmailConstants');
  var connect = require('share/enhancers/Izenda.Connect');
  const { get, flow, head, isNil } = require('lodash/fp');

  var DatabaseConfiguration = React.createClass({
    propTypes: {
      store: React.PropTypes.object.isRequired
    },

    componentDidMount: function() {
      this.props.store.getSupportedDatabaseType();
    },

    onClickConnectButton: function(e) {
      e.preventDefault();
      var props = this.props;
      var store = props.store;
      var loader = props.loader;
      var localization = props.localization;

      loader.startLoading();

      var valManager = this.props.validation;
      valManager
        .validate('connectionString')
        .then(function(success) {
          return success ? testSuccess() : testFail();
        })
        .finally(loader.endLoading.bind(loader));

      function setupDatabase(resetDataInfo = true) {
        return props
          .confirmMessage('info', localization.getText('LICENSE_CHECKER_MESSAGE_CHANGE_CONNECTION'))
          .then(store.setupDatabase.bind(store, resetDataInfo))
          .then(function(response) {
            if (!response.success) {
              var errorMessage = flow(
                get('messages'),
                head,
                get('messages'),
                head
              )(response);
              return props.confirmMessage('error', errorMessage);
            }
            return store.getConnectionInfo();
          });
      }

      function testSuccess() {
        if (store.licenseInfoStore.licenseInfo.isActiveLicense && store.databaseConfiguration.differentDatabase) {
          return props
            .confirmFn('Confirmation', {
              description: LicenseCheckerConstants.MESSAGE.MG07
            })
            .then(function() {
              return setupDatabase();
            });
        }
        return setupDatabase(false);
      }

      function testFail() {
        if (
          store.databaseConfiguration.hasValidConnection &&
          !isNil(store.databaseConfiguration.connectionInfo.connectionString)
        ) {
          return props.confirmMessage('info', LicenseCheckerConstants.MESSAGE.MG08).then(function() {
            valManager.reset('connectionString');
            store.databaseConfiguration.resetDataInfo();
            return store.getConnectionInfo();
          });
        }
        return null;
      }
    },

    render: function() {
      var store = this.props.store;
      var localization = this.props.localization;
      return (
        <Panel header={LicenseCheckerConstants.Description} className='panel-default'>
          {/* connection string form*/}
          <ConnectionStringForm store={store} />

          {/* buttons*/}
          <fieldset>
            <div className='u_textRight'>
              <a className='icon-mail u_marginRight' href={EmailConstants.EMAIL.connectionStringAssistance} />
              <button className='btn btn-primary' ref='connectButton' onClick={this.onClickConnectButton}>
                {localization.getText('COMMON_LABEL_CONNECT')}
              </button>
            </div>
          </fieldset>
        </Panel>
      );
    }
  });

  module.exports = connect()(DatabaseConfiguration);
})();



// WEBPACK FOOTER //
// ./ui/modules/Settings/LicenseChecker/Izenda.DatabaseConfiguration.jsx